module.exports = __webpack_public_path__ + "static/media/logo-gmail.f03ff420.png";